import { useState } from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  useTranslate,
  useUpdate,
  BooleanInput
} from "react-admin";
import { useNavigate } from "react-router-dom";
import CustomHeaderActions from "./CustomHeaderActions";
import ShowAndEditDetails from "./ShowAndEditDetails";
import { PlatformSettingsIcon } from "../assets/Icons";
import { CustomToolbar } from "./CustomToolbar";

export default function PlatformEdit() {
  const translate = useTranslate();
  const [edit] = useUpdate();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const submit = async (data: any) => {
    setIsLoading(true);
    edit(
      "Platform",
      {
        id: data.id,
        data: {
          ...data,
          amount_billed_per_appointment: String(
            data.amount_billed_per_appointment
          ),
          service_price_per_month: String(data.service_price_per_month),
          percent_billed_from_pos: String(data.percent_billed_from_pos)
        }
      },
      {
        onSuccess: () => {
          setIsLoading(false);
          navigate(`/dashboard/Platform/${data.id}/show`);
        },
        onError: () => {
          setIsLoading(false);
        }
      }
    );
  };

  return (
    <Edit
      redirect="show"
      actions={
        <CustomHeaderActions title={translate("platform.platform_settings")} />
      }
    >
      <SimpleForm
        onSubmit={submit}
        toolbar={<CustomToolbar isLoading={isLoading} />}
      >
        <ShowAndEditDetails
          title={translate("platform.platform_settings_details")}
          view="edit"
          icon={<PlatformSettingsIcon />}
        />
        <TextInput
          source="contact_email"
          label={translate("platform.contact_email")}
          fullWidth
        />
        <NumberInput
          source="amount_billed_per_appointment"
          label={translate("platform.amount_billed_per_appointment")}
          fullWidth
        />
        <NumberInput
          source="service_price_per_month"
          label={translate("platform.service_price_per_month")}
          fullWidth
        />
        <NumberInput
          source="percent_billed_from_pos"
          label={translate("platform.percent_billed_from_pos")}
          fullWidth
        />
        <NumberInput
          source="appointment_reminder_hours_before"
          label={translate("platform.appointment_reminder_hours_before")}
          fullWidth
        />
        <TextInput
          source="approved_emails"
          label={translate("platform.approved_emails")}
          fullWidth
        />
        <BooleanInput
          source="feature_flag_restricted_sign_up"
          label={translate("platform.feature_flag_restricted_sign_up")}
          fullWidth
        />
      </SimpleForm>
    </Edit>
  );
}
